import "../../design/register.css";
import { useEffect, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "axios";
import Select from "react-select";
import Loading from "../../utils/components/Loading";
import Toast from "../../utils/components/Toast";
import { subjects } from "../../utils/functions/subjectsOfSchool";
import { API_URL, WEBSITE_URL } from "../../api/API_SERVERS";

let defaultObject = {
    Person_ID: "",
    Email: "",
    Fullname: "",
    lession_location: "",
    Subjects: [{ name: "", experience: "", level: "", price: "", lesson_location: false}],
    Location: [],
    Address: "",
    Mobile_Number: "",
    Password: "",
};

// Custom icon for markers
const teacherIcon = L.icon({
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
});

const experienceOptions = [
    { value: "0-1", label: "0-1 წელი" },
    { value: "2-5", label: "2-5 წელი" },
    { value: "6-10", label: "6-10 წელი" },
    { value: "10+", label: "10+ წელი" },
];

const levelOptions = [
    { value: "დაწყებითები", label: "დაწყებითები" },
    { value: "საშუალო", label: "საშუალო" },
    { value: "უმაღლესი", label: "უმაღლესი" },
    { value: "დაწყებითები+საშუალო", label: "დაწყებითები+საშუალო" },
    { value: "საშუალო+უმაღლესი", label: "საშუალო+უმაღლესი" },
    { value: "დაწყებითები+უმაღლესი", label: "დაწყებითები+უმაღლესი" },
    { value: "ყველა", label: "ყველა" },
];

const customSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: "42px",
        borderRadius: "8px",
        borderColor: state.isFocused ? "#4CAF50" : "#ccc",
        boxShadow: state.isFocused ? "0 0 0 2px rgba(76,175,80,0.2)" : "none",
        "&:hover": {
            borderColor: "#4CAF50",
        },
        fontSize: "12px"
    }),
    menu: (base) => ({
        ...base,
        borderRadius: "10px",
        overflow: "hidden",
        fontSize: "12px",
    }),
};

export default function Register() {
    const defaultCenter = [41.7500, 44.8400];

    const [location, setLocation] = useState(null);
    const [personInformation, setPersonInformation] = useState(defaultObject);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [checkbox, setCheckbox] = useState(false);
    const [toast, setToast] = useState(null);
    const [passwordRules, setPasswordRules] = useState({});
    const [passwordStrength, setPasswordStrength] = useState("");

    const showToast = (message, type = "error") => {
        setToast({ message, type });
    };

    // PASSWORD VALIDATION
    const validatePassword = (password, confirmPassword) => {
        return {
            length: password.length >= 8,
            lowercase: /[a-z]/.test(password),
            uppercase: /[A-Z]/.test(password),
            number: /[0-9]/.test(password),
            special: /[!@#$%^&*]/.test(password),
            isMatch: password === confirmPassword && password !== "",
        };
    };

    // const passwordsMatch = (password, confirmPassword) =>
    //     password === confirmPassword && confirmPassword.length > 0;

    const getStrength = (rules) => {
        const passed = Object.values(rules).filter(Boolean).length;
        if (passed <= 2) return "weak";
        if (passed <= 4) return "medium";
        return "strong";
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setPersonInformation((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // DYNAMIC SUBJECTS + EXPERIENCE
    const sortedSubjectsOptions = subjects
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((s) => ({ value: s.value, label: s.label }));

    const addSubjectField = () => {
        if (personInformation.Subjects.length >= sortedSubjectsOptions.length) return;
        setPersonInformation((prev) => ({
            ...prev,
            Subjects: [
                ...prev.Subjects,
                { name: "", experience: "", level: "", price: "", lesson_location: false },
            ],
        }));
    };

    const removeSubjectField = (index) => {
        setPersonInformation((prev) => ({
            ...prev,
            Subjects: prev.Subjects.filter((_, i) => i !== index),
        }));
    };

    const handleSubjectChange = (index, key, value) => {
        setPersonInformation((prev) => {
            const newSubjects = [...prev.Subjects];
            if (key === "name") {
                const alreadySelected = newSubjects.some(
                    (sub, i) => sub.name === value && i !== index
                );
                if (alreadySelected) return prev;
            }
            newSubjects[index][key] = value;
            return { ...prev, Subjects: newSubjects };
        });
    };

    // HANDLE SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();

        // BASIC VALIDATION
        const { Person_ID, Email, Fullname, Address, Salary_Per_Hour, Mobile_Number, Password, Subjects } =
            personInformation;

        if (!Person_ID || !Email || !Fullname || !Address || !Mobile_Number || !Password) {
            showToast("ყველა ველი შევსებული უნდა იყოს");
            return;
        }

        if (Person_ID.length !== 11 || !/^\d+$/.test(Person_ID)) {
            showToast("პირადი ნომერი უნდა შეიცავდეს 11 ციფრს");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(Email)) {
            showToast("ელ-ფოსტის ფორმატი არასწორია");
            return;
        }

        if (!/^[a-zA-Zა-ჰ\s]+$/.test(Fullname)) {
            showToast("სახელი გვარი შეიცავს არასწორ სიმბოლოებს");
            return;
        }

        for (let sub of Subjects) {
            if (!sub.name) {
                showToast("აირჩიეთ ყველა საგანი");
                return;
            }

            if (!["0-1", "2-5", "6-10", "10+"].includes(sub.experience)) {
                showToast("გამოცდილება არასწორია");
                return;
            }

            if (
                ![
                    "დაწყებითები",
                    "საშუალო",
                    "უმაღლესი",
                    "დაწყებითები+საშუალო",
                    "საშუალო+უმაღლესი",
                    "დაწყებითები+უმაღლესი",
                    "ყველა",
                ].includes(sub.level)
            ) {
                showToast("მოსწავლეთა დონე არასწორია");
                return;
            }

            if (!/^\d+$/.test(String(sub.price))) {
                showToast("ფასი უნდა იყოს რიცხვი");
                return;
            }

            const priceNum = Number(sub.price);
            if (priceNum < 10 || priceNum > 200) {
                showToast("ფასი უნდა იყოს 10-200 ლარი");
                return;
            }
        }

        const salaryNum = Number(Salary_Per_Hour);
        if (salaryNum < 10 || salaryNum > 100) {
            showToast("ანაზღაურება 10-100");
            return;
        }

        if (!/^\d{9}$/.test(Mobile_Number)) {
            showToast("მობ ნომერი უნდა იყოს 9 ციფრი");
            return;
        }

        // PASSWORD VALIDATION
        const rules = validatePassword(Password, confirmPassword);
        const { isMatch, ...passwordRequirements } = rules;
        const allValid = Object.values(passwordRequirements).every(Boolean);

        if (!allValid) {
            showToast("პაროლი არ აკმაყოფილებს მოთხოვნებს!");
            return;
        }

        if (!isMatch) {
            showToast("პაროლები არ ემთხვევა ერთმანეთს!");
            return;
        }

        if (!location) {
            showToast("თქვენ არ მოგინიშნიათ თქვენი მისამართი რუკაზე!");
            return;
        }

        // SUBMIT
        try {
            setLoading(true);

            const payload = {
                personId: Person_ID,
                email: Email,
                fullname: Fullname,
                subject: Subjects.map(sub => ({
                    name: sub.name,
                    experience: sub.experience,
                    level: sub.level,
                    price: Number(sub.price),
                    lesson_location: sub.lesson_location ?? false, // 💥 THIS FIXES EVERYTHING
                })),
                location: location,
                address: Address,
                mobileNumber: Mobile_Number,
                password: Password,
            };

            console.log(payload.subject[0]);

            await axios.post(`${API_URL}/api/teachers/register`, payload);

            showToast("რეგისტრაცია წარმატებით დასრულდა!", "success");

            setTimeout(() => window.location.assign("/login"), 1000);
        } catch (error) {
            const message = error.response?.data?.message || "დაფიქსირდა შეცდომა";
            showToast(message);
        } finally {
            setLoading(false);
        }
    };

    // MAP CLICK
    const MapClickHandler = () => {
        const map = useMap();
        useEffect(() => {
            const handleClick = (event) => {
                const { lat, lng } = event.latlng;
                const newLocation = [lat, lng];
                setLocation(newLocation);
                setPersonInformation((prev) => ({ ...prev, Location: newLocation }));
            };
            map.on("click", handleClick);
            return () => map.off("click", handleClick);
        }, [map]);
        return null;
    };

    return (
        <div className="register-container">
            {loading && <Loading />}
            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(null)}
                />
            )}
            <form className="register-form" onSubmit={handleSubmit}>
                <h2 className="register-title">ანგარიშის შექმნა</h2>

                {/* Fullname */}
                <div className="register-input-group">
                    <label className="register-input-label">სახელი, გვარი:</label>
                    <input
                        name="Fullname"
                        type="text"
                        className="register-input-field"
                        value={personInformation.Fullname}
                        onChange={handleChange}
                        placeholder="გიორგი გიორგაძე"
                        autoComplete="off"
                        required
                    />
                </div>

                {/* EMAIL INPUT */}
                <div className="register-input-group">
                    <label className="register-input-label">ელ-ფოსტა:</label>
                    <input
                        name="Email"
                        type="email"
                        className="register-input-field"
                        value={personInformation.Email || ""}
                        onChange={handleChange}
                        placeholder="example@mail.com"
                        autoComplete="email"
                        required
                    />
                    <small style={{fontSize: '10px', color: '#666', marginTop: '4px'}}>
                        გამოიყენება პაროლის აღსადგენად
                    </small>
                </div>

                {/* Address */}
                <div className="register-input-group">
                    <label className="register-input-label">მისამართი სადაც ასწავლით:</label>
                    <input
                        name="Address"
                        type="text"
                        className="register-input-field"
                        value={personInformation.Address}
                        onChange={handleChange}
                        placeholder="მაგ: ანდრიას 3"
                        required
                        autoComplete="off"
                    />
                </div>

                {/* Mobile */}
                <div className="register-input-group">
                    <label className="register-input-label">მობილური ნომერი:</label>
                    <input
                        name="Mobile_Number"
                        type="text"
                        className="register-input-field"
                        value={personInformation.Mobile_Number}
                        onChange={handleChange}
                        placeholder="მაგ: 558******"
                        required
                        autoComplete="off"
                    />
                </div>

                {/* Person ID */}
                <div className="register-input-group">
                    <label className="register-input-label">პ/ნ:</label>
                    <input
                        name="Person_ID"
                        type="text"
                        className="register-input-field"
                        value={personInformation.Person_ID}
                        onChange={handleChange}
                        placeholder="01234567890"
                        required
                        autoComplete="off"
                    />
                </div>

                {/* Dynamic Subjects */}
                <div className={'register-input-group-subject-space'}>
                    <h3>საგნები</h3>
                    {personInformation.Subjects.map((sub, index) => (
                        <div className="register-subject-card" key={index}>
                            {personInformation.Subjects.length > 1 && (
                                <button
                                    type="button"
                                    className="register-subject-delete"
                                    onClick={() => removeSubjectField(index)}
                                >
                                    ❌
                                </button>
                            )}

                            {/* SUBJECT */}
                            <div className="register-field">
                                <label>საგანი</label>
                                <Select
                                    value={
                                        sub.name
                                            ? {
                                                value: sub.name,
                                                label: sortedSubjectsOptions.find(
                                                    (s) => s.value === sub.name
                                                )?.label,
                                            }
                                            : null
                                    }
                                    options={sortedSubjectsOptions.filter(
                                        (s) =>
                                            !personInformation.Subjects.some(
                                                (subj, i) => subj.name === s.value && i !== index
                                            )
                                    )}
                                    onChange={(selected) =>
                                        handleSubjectChange(index, "name", selected?.value || "")
                                    }
                                    placeholder="აირჩიეთ საგანი"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        ...customSelectStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    required={true}
                                />
                            </div>

                            {/* EXPERIENCE */}
                            <div className="register-field">
                                <label>გამოცდილება</label>
                                <Select
                                    value={
                                        sub.experience
                                            ? experienceOptions.find((opt) => opt.value === sub.experience)
                                            : null
                                    }
                                    options={experienceOptions}
                                    onChange={(selected) =>
                                        handleSubjectChange(index, "experience", selected?.value || "")
                                    }
                                    placeholder="აირჩიეთ გამოცდილება"
                                    isSearchable={false}

                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        ...customSelectStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    required={true}
                                />
                            </div>

                            {/* LEVEL */}
                            <div className="register-field">
                                <label>მოსწავლეთა დონე</label>
                                <Select
                                    value={
                                        sub.level
                                            ? levelOptions.find((opt) => opt.value === sub.level)
                                            : null
                                    }
                                    options={levelOptions}
                                    onChange={(selected) =>
                                        handleSubjectChange(index, "level", selected?.value || "")
                                    }
                                    placeholder="აირჩიეთ დონე"
                                    isSearchable={false}

                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        ...customSelectStyles,
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    required={true}
                                />
                            </div>

                            {/* PRICE */}
                            <div className="register-field">
                                <label>ფასი (1 საათი 10-100)</label>
                                <input
                                    type="number"
                                    className="register-input-field"
                                    value={sub.price}
                                    onChange={(e) =>
                                        handleSubjectChange(index, "price", e.target.value)
                                    }
                                    placeholder="მაგ: 15"
                                    min="10"
                                    max="100"
                                    required={true}
                                />
                            </div>

                            {/* Add this inside the .map loop, ideally after the Price field */}
                            <div className="register-field full-width">
                                <label className="register-location-toggle-label">
                                    <input
                                        type="checkbox"
                                        className="register-location-checkbox"
                                        checked={sub.lesson_location || false}
                                        onChange={(e) =>
                                            handleSubjectChange(index, "lesson_location", e.target.checked)
                                        }
                                    />
                                    <span>მე მივალ მოსწავლესთან (ბინაზე)</span>
                                </label>
                                <p className="location-hint">
                                    ({sub.lesson_location
                                        ? "თქვენ მიდიხართ მოსწავლესთან"
                                        : "მოსწავლე მოდის თქვენთან მითითებულ მისამართზე"})
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {personInformation.Subjects.length < sortedSubjectsOptions.length && (
                    <button
                        type="button"
                        onClick={addSubjectField}
                        className={'add-subject-button'}
                    >
                        დაამატე საგანი სიაში
                    </button>
                )}

                {/* Password */}
                <div className="password-rules-card">
                    {Object.entries({
                        "მინიმუმ 8 სიმბოლო": passwordRules.length,
                        "პატარა ასო (a-z)": passwordRules.lowercase,
                        "დიდი ასო (A-Z)": passwordRules.uppercase,
                        "ციფრი (0-9)": passwordRules.number,
                        "სიმბოლო (!@#$)": passwordRules.special,
                        "პაროლი ემთხვევა": passwordRules.isMatch,
                    }).map(([label, valid], idx) => (
                        <div key={idx} className={`rule-item ${valid ? "valid" : "invalid"}`}>
                            {valid ? "✔️" : "❌"} {label}
                        </div>
                    ))}
                </div>
                <div className="register-input-group password-group">
                    <label className="register-input-label">პაროლი</label>
                    <input
                        name="Password"
                        type="password"
                        className="register-input-field"
                        value={personInformation.Password}
                        onChange={(e) => {
                            const value = e.target.value;
                            handleChange(e);
                            const rules = validatePassword(value, confirmPassword);
                            setPasswordRules(rules);
                            setPasswordStrength(getStrength(rules));
                        }}
                        placeholder="********"
                        required
                    />
                </div>

                <div className="register-input-group">
                    <label className="register-input-label">გაიმეორეთ პაროლი</label>
                    <input
                        type="password"
                        className="register-input-field"
                        value={confirmPassword}
                        onChange={(e) => {
                            const value = e.target.value;
                            setConfirmPassword(value);
                            const rules = validatePassword(personInformation.Password, value);
                            setPasswordRules(rules);
                            setPasswordStrength(getStrength(rules));
                        }}
                        placeholder={'********'}
                        required
                    />
                    <div className="password-strength-bar">
                        <div className={`strength ${passwordStrength}`} />
                        <span className="strength-label">{passwordStrength}</span>
                    </div>
                </div>

                {/* Terms */}
                <div className={"registerRulesSpace"}>
                    <div
                        className={"registerRules"}
                        onClick={() => window.open(`${WEBSITE_URL}/terms-and-conditions`)}
                    >
                        წესები და პირობები
                    </div>
                </div>
                <div className={"register-input-checkbox"}>
                    <label htmlFor="terms-checkbox">
                        გავეცანი და ვეთანხმები წესებსა და პირობებს
                    </label>
                    <input
                        className={"registerTermsInput"}
                        id="terms-checkbox"
                        type={"checkbox"}
                        checked={checkbox}
                        onChange={() => setCheckbox(!checkbox)}
                        required
                    />
                </div>

                <button type="submit" className="register-submit-button" disabled={loading}>
                    რეგისტრაცია
                </button>

                <p className="register-login-prompt">
                    უკვე გაქვს ანგარიში?{" "}
                    <a href="/login" className="register-login-link">
                        ავტორიზაცია
                    </a>
                </p>
            </form>

            {/* MAP */}
            <div className="registerMapSpace">
                <MapContainer
                    center={location || defaultCenter}
                    zoom={12}
                    className="registerMap"
                    maxZoom={18}

                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <MapClickHandler />
                    {location && (
                        <Marker position={location} icon={teacherIcon}>
                            <Popup>
                                <strong>{personInformation.Fullname || "New Teacher"}</strong>
                                <br />
                                {personInformation.Subjects.map((s) => s.name).join(", ") || "Subject TBD"}
                                <br />
                                {personInformation.Address || "Address TBD"}
                            </Popup>
                        </Marker>
                    )}
                </MapContainer>
            </div>
        </div>
    );
}